
import React, {useEffect, useState, useReducer} from 'react'
import Navbar from '../hero/Navbar'
import './BookingSummary.css'
import {GoLocation} from 'react-icons/go'
import Footer from '../Footer/Footer'
import { useLocation  } from 'react-router-dom'
import moment from "moment";

import hotelplace from '../../assets/hotelplace.webp';
import { getHotelImage } from '../../assets/hotelImages';

const BookingSummary = () => {
    const [date, setDate] = useState();
    const [reducerValue, forceUpdate] = useReducer(x => x + 1, 0)
 
    useEffect(() => {
      const date = new Date()
      const formattedDate = moment(date).format("YYYY-MM-DD HH : mm : ss");
      setDate(formattedDate);

     
    },[])

    const history = useLocation()
    const { allBookingDetails, roomTypes, bookCode, taxDetails } =
      history.state;


  return (
    <div>
      <Navbar />
      <div className='container'>
        <div className='parent_summ'>
          <div className='row heardpart'>
            <div className=' col-md-6'>
              <span>Booking Date : {date}</span>
            </div>
            <div className='col-md-6'>
              <span>Booking Code : {bookCode && bookCode}</span>
            </div>
          </div>

          <div className='row detailPart'>
            <div className=' col-md-8'>
              {/* <p className='NB'>
                NB: This payment is valid for only one time check-in{" "}
              </p> */}
              <p className='text'>
                Thank you for booking with us! We are excited to have you as a
                guest. Your booking confirmation email has been sent to{" "}
                <span className='email'>
                  {history.state &&
                    history.state.allBookingDetails.payingGuest.emailAddress}
                </span>
                . Please check your inbox for the email. The email will contain
                a copy of your booking receipt, as well as all of the important
                details about your stay. If you have any questions, please do
                not hesitate to contact us. We look forward to seeing you soon!
              </p>
              <h3>
                {history.state && history.state.allBookingDetails.hotelName}
              </h3>
              <p>
                {" "}
                <GoLocation className='locate' />{" "}
                {history.state && history.state.roomTypes.address}
              </p>
              <p></p>
              <table className='table table-striped table-hover'>
                <tbody>
                  <tr>
                    <th scope='row'>Guest Name</th>
                    <td>
                      {history.state &&
                        history.state.allBookingDetails.payingGuest
                          .lastName}{" "}
                      {history.state &&
                        history.state.allBookingDetails.payingGuest.firstName}
                    </td>
                  </tr>
                  <tr>
                    <th scope='row'>Guest Email</th>
                    <td>
                      {history.state &&
                        history.state.allBookingDetails.payingGuest.email}
                    </td>
                  </tr>
                  <tr>
                    <th scope='row'>Mobile Number</th>
                    <td>
                      {history.state &&
                        history.state.allBookingDetails.payingGuest.phoneNumber}
                    </td>
                  </tr>
                  <tr>
                    <th scope='row'>Check-in Date</th>
                    <td>
                      {history.state &&
                        history.state.allBookingDetails.checkInDate}
                    </td>
                  </tr>
                  <tr>
                    <th scope='row'>Check-Out Date</th>
                    <td>
                      {history.state &&
                        history.state.allBookingDetails.checkOutDate}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className='col-md-4'>
              <div className='imgDiv'>
                <img
                  src={history.state && history.state.roomTypes.picture}
                  onError={(e) => {
                    const match = getHotelImage(history.state?.allBookingDetails?.hotelName);
                    if (match && e.target.src !== match) {
                      e.target.src = match;
                    } else {
                      e.target.src = hotelplace;
                    }
                  }}
                  alt='hotel image'
                />
              </div>
            </div>
          </div>
          <div> </div>
          <br />
          <br />
          <div className='container tableDiv'>
            <br />
            <br />

            <div className='row'>
              <div className='col-md-12 tableScroll'>
                <table className='table table-striped table-hover table2'>
                  <thead>
                    <tr>
                      <th scope='col'>S/N</th>
                      <th scope='col'>Room Type</th>
                      <th scope='col'>Quantity</th>
                      <th scope='col'>No of Days</th>
                      <th scope='col'>Room price</th>
                      <th scope='col'>Total</th>
                    </tr>
                  </thead>
                  {history.state &&
                    history.state.allBookingDetails.bookings.map(
                      (booking, index) => (
                        <tbody>
                          <tr>
                            <th scope='row'>{index + 1}</th>
                            <td>{booking.roomTypeName}</td>
                            <td>{booking.qty}</td>
                            <td>{booking.lengthOfStay}</td>
                            <td>
                              &#x20A6; {booking.roomCost.toLocaleString()}
                            </td>
                            <td>
                              &#x20A6;{" "}
                              {(
                                booking.totalCost * booking.lengthOfStay
                              ).toLocaleString()}
                            </td>
                          </tr>
                        </tbody>
                      )
                    )}
                  <br />

                  {taxDetails &&
                    taxDetails.map((tax) => (
                      <tr style={{ color: "#3C3C3C", fontSize: "0.8em" }}>
                        <th
                          scope='row'
                          colSpan='2'
                          style={{ textAlign: "justify" }}
                        >
                          {tax.taxLabel} {" "} ({tax.percentageOrFlatAmount})
                          {tax.type === "flatAmount" ? "" : "%"}
                        </th>
                        <td colSpan='1' style={{ textAlign: "justify" }}>
                          {" "}
                          &#x20A6; {tax.amount.toLocaleString()}
                        </td>
                      </tr>
                    ))}
                  <br />
                  <tr style={{ color: "green", borderTop: "1px solid grey" }}>
                    <th
                      scope='row'
                      colSpan='2'
                      style={{ textAlign: "justify" }}
                    >
                      Total Amount Paid
                    </th>
                    <td colSpan='1' style={{ textAlign: "justify" }}>
                      {" "}
                      &#x20A6;{" "}
                      {history.state &&
                        history.state.allBookingDetails.totalBill.toLocaleString()}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default BookingSummary